import { Outlet } from 'react-router-dom'
import AppLayout from '@/components/layout/app-layout'
import { TabAccessProvider } from '@/hooks/use-tab-access'

export default function ProtectedLayout() {
  return (
    <TabAccessProvider>
      <AppLayout>
        <Outlet />
      </AppLayout>
    </TabAccessProvider>
  )
}
